import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/_services/user.service';
import Swal from 'sweetalert2';

import { User } from './../../../_models/user';

@Component({
  selector: 'app-register-step-three-verify-by-link',
  templateUrl: './register-step-three-verify-by-link.component.html',
  styleUrls: ['./register-step-three-verify-by-link.component.css']
})
export class RegisterStepThreeVerifyByLinkComponent implements OnInit {
  vcode=undefined
  email=undefined
  loading=false
  responseMessage = '';
  errorEncountered=false

  isRegistrationSuccess=false
  roles: string[] = [];
  constructor( private userService:UserService,private router:Router,private aRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loading=true
    this.aRoute.params.subscribe(
      p=>{
        this.vcode =p['vcode']
        this.aRoute.queryParams.subscribe(
          q=>{
            this.email=q['ux']
            if(this.vcode && this.email){
              let user = new User()
              user.vcode = this.vcode
              //let ppp = new Profile()
              //ppp.email = this.email

              this.userService.verify(user).subscribe(
                rsData=>{

                  let status =+rsData['status']
                  this.loading=false
                  if(status==1){
                    //this.userService.isNewRegistrationSubject.next(false)
                    this.router.navigate(['/user/new/step/verification/success'])
                    this.isRegistrationSuccess=true
                  }else{
                    this.isRegistrationSuccess=false
                    this.responseMessage=rsData['message']
                    this.errorEncountered=true
                    Swal.fire( 'Oops',rsData['message'],'info')
                  }

                }
              )
            }
          }
        )
      }
    )


  }

}
